import http from "./base";

class ItemheaderService{
    constructor(){}

    async saveNewItemheader(itemheaderItem) {
        const url = `itemHeaders`;
        var response = "";
        await http
            .post(url, itemheaderItem,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async updateItemheaderByID(id,body) {
        const url = `itemHeaders/`+id;
        var response = "";
        await http
            .patch(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async updateAllItemheaders(body) {
        const url = `itemHeaders/all`;
        var response = "";
        await http
            .post(url,body,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }

    async deleteItemheaderID(id) {
        const url = `itemHeaders/`+id;
        var response = "";
        await http
            .delete(url,{
                headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }


    async getAllItemheaders(venueID)  {
        const url = `itemHeaders/getAll/`+venueID;

        var response = "";
        await http
            .get(url, {
                cache: false
            })
            .then(responseData => {
                response = responseData.data.data;
            })
            .catch(error => {
                response = error.response;
                throw new Error(`HTTP error! status: ${response.status}`);
            });

        return response;
    }



}

let service = new ItemheaderService();
export default service;



